// extracted by mini-css-extract-plugin
export default {"pendingDot":"pendingDot--uRjx3"};